var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCyberpunk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 560,
    viewBox: "0 0 360 560",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gcyber",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fc00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00dbde"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 560,
    fill: "url(#gcyber)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.3)",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 400,
    width: 30,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 360,
    width: 25,
    height: 160
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 380,
    width: 35,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 420,
    width: 28,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 390,
    width: 32,
    height: 130
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 410,
    width: 28,
    height: 110
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberpunk);
export default __webpack_public_path__ + "static/media/cyberpunk.8718c72255414f1fbff717033d9d90a2.svg";
export { ForwardRef as ReactComponent };